import { GRADING_AVERAGE_LABEL, GRADING_SCALE_LABEL, SCALE_OPTIONS } from "./consts";
import validateNumber from "../validateNumber";
import validateSelect from "../validateSelect";
export function validateMax(scale) {
  return validateSelect(GRADING_SCALE_LABEL, scale, SCALE_OPTIONS);
}
export function validateGrade(grade, max) {
  if (max === '') {
    return '';
  }
  return validateNumber(GRADING_AVERAGE_LABEL, grade, max);
}